import React, { ReactNode } from 'react';
import {
  FooterActionsContainer,
  FooterContainer,
  FooterDescription,
  FooterPrice
} from './styled';
import useScreenSize from '../../../../hooks/useScreenSize';
import { BottomPhoneButton } from '../../BottomPhoneButton';
import { PhoneButtonClickHandler } from '../../BottomPhoneButton/types';

interface GalleryFooterProps {
  price: string;
  description?: ReactNode;
  isAuthor: boolean;
  phones?: string[] | null;
  isShowPhones: boolean;
  setClickOnGallery: PhoneButtonClickHandler;
}

export const GalleryFooter: React.FC<GalleryFooterProps> = ({
  price,
  description,
  isAuthor,
  phones,
  isShowPhones,
  setClickOnGallery
}) => {
  const { isSmall } = useScreenSize();

  return (
    <FooterContainer>
      <div className="gallery-ads-info">
        <FooterPrice tag={isSmall ? 'h2' : 'h2_new'}>{price}</FooterPrice>
        <FooterDescription tag={isSmall ? 'caption_1_new' : 'body_3'}>
          {description}
        </FooterDescription>
      </div>

      {isShowPhones && !isAuthor && (
        <FooterActionsContainer>
          <BottomPhoneButton
            stat="product-call-btn"
            isGallery
            isIconButton
            clickHandler={setClickOnGallery}
            isAuthor={isAuthor}
            phones={phones}
          />
        </FooterActionsContainer>
      )}
    </FooterContainer>
  );
};
